"use strict";
// Netflix-like picker: a native grouped style menu, then a grid of avatars in that style.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var components_2 = require("stremio/routes/Settings/components");
var avatars_1 = require("./avatars");
var ProfileGate_less_1 = __importDefault(require("./ProfileGate.less"));
var AvatarPicker = function (_a) {
    var _b;
    var value = _a.value, onChange = _a.onChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var selected = (0, avatars_1.parseAvatar)(value);
    var _c = (0, react_1.useState)((_b = selected === null || selected === void 0 ? void 0 : selected.style) !== null && _b !== void 0 ? _b : avatars_1.DEFAULT_AVATAR_STYLE), style = _c[0], setStyle = _c[1];
    var _d = (0, react_1.useState)(function () {
        var random = Array.from({ length: avatars_1.AVATAR_CHOICES }, avatars_1.randomSeed);
        return selected ? __spreadArray([selected.seed], random.slice(1), true) : random;
    }), seeds = _d[0], setSeeds = _d[1];
    var styleOptions = (0, react_1.useMemo)(function () { return avatars_1.AVATAR_STYLE_GROUPS.flatMap(function (group) { return __spreadArray([
        { label: t(group.label), value: "group:".concat(group.label), header: true }
    ], group.styles.map(function (id) { return ({ label: (0, avatars_1.styleLabel)(id), value: id }); }), true); }); }, [t]);
    var onStyleSelect = (0, react_1.useCallback)(function (nextStyle) {
        setStyle(nextStyle);
        onChange((0, avatars_1.makeAvatar)(nextStyle, seeds[0]));
    }, [seeds, onChange]);
    var shuffle = (0, react_1.useCallback)(function () {
        setSeeds(Array.from({ length: avatars_1.AVATAR_CHOICES }, avatars_1.randomSeed));
    }, []);
    // Dice: any style, fresh seeds, and the first one picked right away.
    var rollDice = (0, react_1.useCallback)(function () {
        var allStyles = avatars_1.AVATAR_STYLE_GROUPS.flatMap(function (group) { return group.styles; });
        var nextStyle = allStyles[Math.floor(Math.random() * allStyles.length)];
        var nextSeeds = Array.from({ length: avatars_1.AVATAR_CHOICES }, avatars_1.randomSeed);
        setStyle(nextStyle);
        setSeeds(nextSeeds);
        onChange((0, avatars_1.makeAvatar)(nextStyle, nextSeeds[0]));
    }, [onChange]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_2.Option, { label: 'PLUS_PROFILES_AVATAR_STYLE' },
            react_1.default.createElement(components_1.MultiselectMenu, { className: 'multiselect', options: styleOptions, value: style, onSelect: onStyleSelect })),
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['avatar-grid'] }, seeds.map(function (seed) {
            var _a;
            var avatar = (0, avatars_1.makeAvatar)(style, seed);
            return (react_1.default.createElement(components_1.Button, { key: seed, className: (0, classnames_1.default)(ProfileGate_less_1.default['avatar-choice'], (_a = {}, _a[ProfileGate_less_1.default['selected']] = avatar === value, _a)), title: (0, avatars_1.styleLabel)(style), onClick: function () { return onChange(avatar); } },
                react_1.default.createElement("img", { className: ProfileGate_less_1.default['avatar-image'], src: (0, avatars_1.avatarUrl)(style, seed), alt: '', loading: 'lazy', draggable: false })));
        })),
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['avatar-actions'] },
            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['shuffle']), onClick: shuffle }, t('PLUS_PROFILES_AVATAR_MORE')),
            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(ProfileGate_less_1.default['button'], ProfileGate_less_1.default['dice']), title: t('PLUS_PROFILES_AVATAR_RANDOM'), onClick: rollDice },
                react_1.default.createElement("svg", { className: ProfileGate_less_1.default['dice-icon'], viewBox: '0 0 24 24', "aria-hidden": true },
                    react_1.default.createElement("rect", { x: '3', y: '3', width: '18', height: '18', rx: '4', fill: 'none', stroke: 'currentColor', strokeWidth: '2' }),
                    react_1.default.createElement("circle", { cx: '8', cy: '8', r: '1.5', fill: 'currentColor' }),
                    react_1.default.createElement("circle", { cx: '16', cy: '8', r: '1.5', fill: 'currentColor' }),
                    react_1.default.createElement("circle", { cx: '12', cy: '12', r: '1.5', fill: 'currentColor' }),
                    react_1.default.createElement("circle", { cx: '8', cy: '16', r: '1.5', fill: 'currentColor' }),
                    react_1.default.createElement("circle", { cx: '16', cy: '16', r: '1.5', fill: 'currentColor' }))))));
};
exports.default = AvatarPicker;
